<template>
  <modal
    :show.sync="isActiveLocal"
    size="lg"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pb-8">
      <div class="flex">
        <img
          :src="selectedTesimonial.userImg"
          alt="user"
          class="
            md:h-32
            lg:h-32
            h-16
            md:w-32
            lg:w-32
            w-16
            md:mx-4
            lg:mx-4
            rounded-full
          "
        />
        <div class="mx-2 my-auto">
          <p class="font-medium text-lg md:text-2xl text-black">
            {{ selectedTesimonial.name }}
          </p>
          <p class="clr777 font-normal md:text-lg lg:text-lg text-sm">
            {{ selectedTesimonial.description }}
          </p>
        </div>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>

    <div v-html="selectedTesimonial.html"></div>
    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTesimonial: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
